import React, { useEffect, useState } from "react";
import Input from "../modules/Input";
import DocUpload from "../modules/DocUpload";
import { useDispatch, useSelector } from "react-redux";
import { modifySpoc, modifySpocTotal } from "./redux/actions";
import StaticItem from "../modules/StaticItem";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Button from "../modules/Button";

function BankDetails() {
  const dispatch = useDispatch();
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const spoc = useSelector((state) => state.spoc.pageInfo);
  const [uploading, setUploading] = useState(false);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [isModal, showModal] = useState({ show: false, msg: "", type: "" });

  const addData = (type, data) => {
    dispatch(modifySpoc([type, data]));
  };
  const getSpoc = () => {
    let count = 0;
    let total = 0;
    let countList = [];
    let totalList = [];
    for (let i in spoc) {
      if (
        i === "accName" ||
        i === "bankName" ||
        i === "branchName" ||
        i === "ifscCode" ||
        i === "accNo" ||
        i === "confirmAccNo" ||
        i === "collegePANCard" ||
        i === "cancelledCheque" ||
        i === "addressProof"
      ) {
        if (
          i === "collegePANCard" ||
          i === "cancelledCheque" ||
          i === "addressProof"
        ) {
          if (docs && docs[i]) {
            count += 1;
            countList = [...countList, i];
          }
        } else if (spoc[i]) {
          count += 1;
          countList = [...countList, i];
        }
        total += 1;
        totalList = [...totalList, i];
        // else {
        // total += 1;
        // totalList = [...totalList, i];

        // }
      }
    }
    let finalpercentage = Math.floor(Math.abs(count / total) * 100);

    // setAllTotal({ ...allTotal, personal: finalpercentage });
    dispatch(modifySpocTotal(["bank", finalpercentage]));
  };
  const uploadDoc = async (type, e) => {
    e = validateFileName(e);
    if (e) {
      const formData = new FormData();
      formData.append("file", e);
      formData.append("name", e.name);
      formData.append("size", e.size);
      formData.append("documentType", type);
      formData.append("fileType", e.type.split("/")[1]);
      let id = "";
      if (docs && docs[type]) {
        id = docs[type]["id"];
      }
      if (id) {
        formData.append("id", id);
      }
      try {
        const result = await api.uploadDocument(
          "application",
          tokenData.applicationData.id,
          tokenData.token,
          formData
        );
        // addData(type, '')
        return result;
      } catch (err) {
        console.log("error", err.data);
      }
    }
  };
  const delDoc = async (type, e) => {
    // addData(type, e);
    // if (personalInfo[type]) {
    e = validateFileName(e);
    if (e) {
      try {
        setUploading(true);
        const formData = new FormData();
        let file;
        if (docs[type]) {
          file = docs[type];
        }
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", type);
        formData.append("fileType", e.type.split("/")[1]);
        if (file) {
          formData.append("id", file.id);
        }
        // try {
        const result = await api.uploadDocument(
          "application",
          tokenData.applicationData.id,
          tokenData.token,
          formData
        );
        addData(type, "");
        if (result?.statusCode == 200) {
          // setAlertType({
          //   ...alertType,
          //   msg: "Your Document has been uploaded successfully!",
          // });
          // setAlert(true);
          alert("Your Document has been uploaded successfully!");

          // setTimeout(() => setAlert(false), 3000);
        }
        const docs2 = await getDoc();
        dispatch(addTokenInfo(["docs", docs2.data]));
        setUploading(false);
        addData("photo", "");
        // if (docs2[type]) {
        //   addData("photo", "data");
        // }
      } catch (error) {
        // alert("Sorry! Something went wrong, Please try again.");
        console.error("Error uploading document:", error);
        setUploading(false);
      }
    }
    console.log("type", type);
    // }
  };
  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      showModal({
        ...isModal,
        show: true,
        msg: "File with double extensions is not allowed.",
      });
      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const getDoc = async () => {
    try {
      const docs2 = await api.getDocuments(
        "application",
        tokenData.applicationData.id,
        tokenData.token
      );
      return docs2;
    } catch (err) {
      console.log("error", err.data);
    }
  };
  const handleUpload = async (type, e) => {
    try {
      setUploading(true);
      const uploadResult = await uploadDoc(type, e);
      console.log("upload result", uploadResult);
      if (uploadResult?.statusCode == 200) {
        //   setAlertType({
        //     ...alertType,
        //     msg: "Your Document has been uploaded successfully!",
        //   });
        alert("Your Document has been uploaded successfully!");
        // setAlert(true);
        // setTimeout(() => setAlert(false), 3000);
      }
      addData(type, "");
      const docs2 = await getDoc();
      dispatch(addTokenInfo(["docs", docs2.data]));
      setUploading(false);
      addData("photo", null);
      if (docs2.data.profilePicture) {
        addData("photo", "data");
      }
    } catch (error) {
      // alert("Sorry! Something went wrong, Please try again.");
      console.error("Error uploading document:", error);
      setUploading(false);
    }
  };
  useEffect(() => {
    getSpoc();
  }, [spoc]);
  return (
    <div className="bank">
      <div className="field-set set-one set-top">
        <div className="set-left set">
          <div className="set-title">College Bank Account Details</div>
          <Input
            placeholder={"Account name"}
            value={spoc.accName || ""}
            onChange={(e) => addData("accName", e.replace(/[^a-zA-Z]/g, ''))}
          />
          <Input
            placeholder={"Bank Name"}
            value={spoc.bankName || ""}
            onChange={(e) => addData("bankName", e)}
          />{" "}
          <Input
            placeholder={"Branch Name"}
            value={spoc.branchName || ""}
            onChange={(e) => addData("branchName", e.replace(/[^a-zA-Z]/g, ''))}
          />{" "}
          <Input
            placeholder={"IFSC Code"}
            value={spoc.ifscCode || ""}
            onChange={(e) => addData("ifscCode", e)}
          />{" "}
          <Input
            placeholder={"Bank Account number"}
            value={spoc.accNo || ""}
            type={"password"}
            id={"aadhar"}
            onChange={(e) => addData("accNo", e)}
          />{" "}
          <Input
            type="password"
            id={"aadhar"}
            placeholder={"Re-enter Bank Account number"}
            value={spoc.confirmAccNo || ""}
            onChange={(e) => addData("confirmAccNo", e)}
          />
          {spoc.confirmAccNo !== "" && spoc.confirmAccNo !== spoc.accNo && (
            <span style={{ color: "red" }} className="option-text">
              Should be same as Bank Account number
            </span>
          )}
        </div>{" "}
        {/* </div> */}
        <div className="set-left set doc-list">
          {/* <div className="field"> */}
          <div className="set-title">Documents to upload</div>
          <div
            className={`field-row upload field ${
              docs && docs?.collegePANCard?.name && "doc-col"
            }`}
          >
            {docs?.collegePANCard ? (
              <div className="doc-item">
                <StaticItem
                  onDelete={(e) => delDoc("collegePANCard", e)}
                  type={"doc"}
                  isEditable={true}
                  title={"PAN Card of the College"}
                  doc={docs?.collegePANCard}
                  docUrl={docs?.collegePANCard?.documentUrl}
                  value={docs?.collegePANCard?.name}
                  size={Math.floor(docs?.collegePANCard?.size / 1024)}
                />
              </div>
            ) : (
              <div className="field file-upload-container">
                <DocUpload
                  title={"PAN Card of the College"}
                  noTooltip={true}
                  // value={
                  //   personalInfo?.BirthCertificate?.name
                  //     ? personalInfo?.BirthCertificate
                  //     : ""
                  // }
                  placeholder={"Upload your college's PAN card"}
                  onChange={(e) => handleUpload("collegePANCard", e)}
                />
                {/* {personalInfo?.BirthCertificate?.name && (
                <Button
                  onClickHandler={() => handleUpload(`BirthCertificate`)}
                  value={uploading ? "Uploading..." : "Upload"}
                  type={"contained"}
                  disabled={uploading}
                />
              )} */}
              </div>
            )}
          </div>
          <div
            className={`field-row upload field ${
              docs && docs?.cancelledCheque?.name && "doc-col"
            }`}
          >
            {docs?.cancelledCheque ? (
              <div className="doc-item">
                <StaticItem
                  onDelete={(e) => delDoc("cancelledCheque", e)}
                  type={"doc"}
                  isEditable={true}
                  title={"Cancelled Cheque of the College Bank Account"}
                  doc={docs?.cancelledCheque}
                  docUrl={docs?.cancelledCheque?.documentUrl}
                  value={docs?.cancelledCheque?.name}
                  size={Math.floor(docs?.cancelledCheque?.size / 1024)}
                />
              </div>
            ) : (
              <div className="field file-upload-container">
                <DocUpload
                  title={"Cancelled Cheque of the College Bank Account"}
                  noTooltip={true}
                  // value={
                  //   personalInfo?.cancelledCheque?.name
                  //     ? personalInfo?.cancelledCheque
                  //     : ""
                  // }
                  placeholder={
                    "Upload a cancelled cheque of your college's bank account"
                  }
                  onChange={(e) => handleUpload("cancelledCheque", e)}
                />
              </div>
            )}
          </div>
          <div
            className={`field-row upload field doc-col ${
              docs && docs?.addressProof?.name && "doc-col"
            }`}
          >
            {docs?.addressProof ? (
              <div className="doc-item">
                <StaticItem
                  onDelete={(e) => delDoc("addressProof", e)}
                  type={"doc"}
                  isEditable={true}
                  title={"College's Proof of Address"}
                  doc={docs?.addressProof}
                  docUrl={docs?.addressProof?.documentUrl}
                  value={docs?.addressProof?.name}
                  size={Math.floor(docs?.addressProof?.size / 1024)}
                />
              </div>
            ) : (
              <div className="field file-upload-container">
                <DocUpload
                  title={"College's Proof of Address"}
                  noTooltip={true}
                  placeholder={"Upload your college's proof of address"}
                  onChange={(e) => handleUpload("addressProof", e)}
                />
              </div>
            )}
          </div>
        </div>{" "}
        {/* </div> */}
      </div>
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
      {isModal.show && (
        <ModalComponent
          className={"disburse-model"}
          show={isModal.show}
          handleClose={() => showModal({ ...isModal, show: false })}
          // title={ModalData.title}
          // content={ModalData.desc}
          noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <div>
              {isModal.msg ===
                "Your Document has been uploaded successfully!" && (
                <img src={tick} alt="tick" />
              )}
            </div>
            <div className="md-title">
              {/* Document uploaded successfully! */}
              {isModal.msg}
            </div>
            {/* <div className="md-desc">
                You will receive email notifications on your scholarship
                payment(s), once disbursed.
              </div> */}
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => showModal(false)}
                type={"contained "}
                value={"OK"}
              />
            </div>
          </div>

          {/* <div className="modal-btn-set">
              <Button
                onClickHandler={() => CancelData()}
                type={"contained override"}
                value={"No"}
              />
              <Button
                onClickHandler={() => nextPage()}
                type={"contained "}
                value={ModalData.type === "confirm" ? "Yes, Submit" :ModalData.type === "cancel" ?"Yes": "Okay"}
              />
            </div> */}
        </ModalComponent>
      )}
    </div>
  );
}

export default BankDetails;
